import { LOCAL_STORAGE_KEYS } from 'constant';

interface Headers {
  Authorization: string;
  'tenant-id'?: string;
}

export default function globalHeaders(
  includeTenantId: boolean = true,
): Headers | {} {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
  const tenant = localStorage.getItem(LOCAL_STORAGE_KEYS.TENANT);

  if (!token) return {};

  const headers: Headers = {
    Authorization: `Bearer ${token}`,
  };

  if (includeTenantId && tenant) {
    headers['tenant-id'] = tenant;
  }

  return headers;
}
